






import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  components: {
    Marketing: () => import('./components/marketing.vue'),
    Traning: () => import('./components/training.vue')
  }
})
export default class Download extends Vue {}
